module.exports = __webpack_public_path__ + "img/av295.20850eb6.png";